import { FC, memo } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './style.module.css';

interface Props {
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const ICON_STYLE = { color: '#737373BF', fontSize: 16 };

export const JournalSearchInput: FC<Props> = memo(
  ({ onSearch, disabled = false }: Props) => (
    <Input
      allowClear
      className={styles.search}
      placeholder="Поиск по ФИО пациента или номеру"
      onChange={onSearch}
      prefix={<SearchOutlined style={ICON_STYLE} />}
      style={{ fontSize: 16 }}
      disabled={disabled}
    />
  ),
);

JournalSearchInput.displayName = 'JournalSearchInput';
